import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressButtonModule } from "@spartacus/storefront";
import { RouterModule } from "@angular/router";
import { I18nModule, UrlModule } from "@spartacus/core";
import { GenCartProceedToCheckoutComponent } from "./cart-proceed-to-checkout.component";

@NgModule({
  imports: [
    CommonModule,
    ProgressButtonModule,
    RouterModule,
    I18nModule,
    UrlModule,
  ],
  declarations: [GenCartProceedToCheckoutComponent],
  exports: [GenCartProceedToCheckoutComponent],
})

export class GenCartProceedToCheckoutModule { }
